import Box from '@mui/material/Box';
import { GenericScheduleEmbed } from '../../app/common/Embed/GenericScheduleEmbed';
import React, { useEffect, useState } from 'react';
import useHotjarUser from '../../hooks/useHotjarUser';

const Time2BookNtai = (props) => {
  const { decodedName, decodedEmail, decodedLastName, decodedMobile } = props;

  useHotjarUser(undefined, {
    firstName: decodedName,
    email: decodedEmail,
  });

  const [mainIframePage, setMainIframePage] = useState();
  const [mainIframeId, setMainIframeId] = useState();

  useEffect(() => {
    setMainIframePage('pompaprogramconsult');
    setMainIframeId('SOIDIV_pompaprogramconsult');
  }, []);

  return (
    <div
      style={{
        margin: 'auto',
        alignItems: 'center',
        display: 'flex',
        maxWidth: '900px',
        justifyContent: 'center',
        flexDirection: 'column',
        paddingBottom: '40px',
        paddingTop: '20px',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'block',
          width: '80%',
          height: '548px',
          maxWidth: '900px',
        }}
      >
        <GenericScheduleEmbed
          iframeId={mainIframeId}
          iframePage={mainIframePage}
          email={decodedEmail}
          name={decodedName}
          lastName={decodedLastName}
          phone={decodedMobile}
        />
      </div>
      <Box mb={2} />
    </div>
  );
};

export default Time2BookNtai;
